import Dashboard from '../../pages/AuthPages/Dashboard';
import ProfilePage from '../../pages/AuthPages/Profile';
import Setting from '../../pages/AuthPages/Setting';
import MedicalRooms from '../../pages/AuthPages/MedicalRooms';
import AddMedicalRooms from '../../pages/AuthPages/AddMedicalRooms';
import Training from '../../pages/AuthPages/Training';
import AddTraining from '../../pages/AuthPages/AddTraining';
import BioMedWaste from '../../pages/AuthPages/BioMedWaste';
import AddBMW from '../../pages/AuthPages/AddBMW';
import Laundry from '../../pages/AuthPages/Laundry';
import AddLaundry from '../../pages/AuthPages/AddLaundry';
import Equipment from '../../pages/AuthPages/Equipment';
import AddEquipment from '../../pages/AuthPages/AddEquipment';
import Handover from '../../pages/AuthPages/Handover';
import AddHandover from '../../pages/AuthPages/AddHandover';
import Inventory from '../../pages/AuthPages/Inventory';
import AddInventory from '../../pages/AuthPages/AddInventory';
import Sterlization from '../../pages/AuthPages/Sterlization';
import AddSterlization from '../../pages/AuthPages/AddSterlization';
import AmbulanceChecklist from '../../pages/AuthPages/AmbulanceChecklist';
import AddAmbulanceChecklist from '../../pages/AuthPages/AddAmbulanceChecklist';
import AmbulanceUtilization from '../../pages/AuthPages/AmbulanceUtilization';
import AddAmbulanceUtilization from '../../pages/AuthPages/AddAmbulanceUtilization';
import FirstAid from '../../pages/AuthPages/FirstAid';
import AddFirstAid from '../../pages/AuthPages/AddFirstAid';
import OpdPage from '../../pages/AuthPages/OpdPages';
import OpdAdd from '../../pages/AuthPages/OpdAdd';
import allModules from './modules';

export type RouteConfig = {
  path: string;
  component: React.FC;
  moduleName?: string;
  permission?: 'view' | 'edit';
};


export const protectedRoutes: RouteConfig[] = [
  { path: 'dashboard', component: Dashboard, moduleName: allModules.Dashboard, permission: 'view' },
  { path: 'myaccount/profile', component: ProfilePage },
  { path: 'myaccount/settings', component: Setting },

  { path: 'medicalRooms', component: MedicalRooms, moduleName: allModules.MedicalRooms, permission: 'view' },
  { path: 'medicalRooms/:id', component: AddMedicalRooms, moduleName: allModules.MedicalRooms, permission: 'edit' },

  { path: 'training', component: Training, moduleName: allModules.Training, permission: 'view' },
  { path: 'training/add', component: AddTraining, moduleName: allModules.Training, permission: 'edit' },

  { path: 'bioMedWaste', component: BioMedWaste, moduleName: allModules.BioMedWaste, permission: 'view' },
  { path: 'bioMedWaste/add', component: AddBMW, moduleName: allModules.BioMedWaste, permission: 'edit' },

  { path: 'laundry', component: Laundry, moduleName: allModules.Laundry, permission: 'view' },
  { path: 'laundry/add', component: AddLaundry, moduleName: allModules.Laundry, permission: 'edit' },

  { path: 'equipment', component: Equipment, moduleName: allModules.Equipment, permission: 'view' },
  { path: 'equipment/add', component: AddEquipment, moduleName: allModules.Equipment, permission: 'edit' },

  { path: 'handover', component: Handover, moduleName: allModules.Handover, permission: 'view' },
  { path: 'handover/:id', component: AddHandover, moduleName: allModules.Handover, permission: 'edit' },

  { path: 'inventory', component: Inventory, moduleName: allModules.Inventory, permission: 'view' },
  { path: 'inventory/:id', component: AddInventory, moduleName: allModules.Inventory, permission: 'edit' },

  { path: 'sterlization', component: Sterlization, moduleName: allModules.Sterlization, permission: 'view' },
  { path: 'sterlization/add', component: AddSterlization, moduleName: allModules.Sterlization, permission: 'edit' },

  { path: 'ambulance/checklist', component: AmbulanceChecklist, moduleName: allModules.AmbulanceChecklist, permission: 'view' },
  { path: 'ambulance/checklist/add', component: AddAmbulanceChecklist, moduleName: allModules.AmbulanceChecklist, permission: 'edit' },

  { path: 'ambulance/utilization', component: AmbulanceUtilization, moduleName: allModules.AmbulanceUtilization, permission: 'view' },
  { path: 'ambulance/utilization/add', component: AddAmbulanceUtilization, moduleName: allModules.AmbulanceUtilization, permission: 'edit' },

  { path: 'firstaid', component: FirstAid, moduleName: allModules.FirstAid, permission: 'view' },
  { path: 'firstaid/add', component: AddFirstAid, moduleName: allModules.FirstAid, permission: 'edit' },

  { path: 'opd', component: OpdPage, moduleName: allModules.Opd, permission: 'view' },
  { path: 'opd/add', component: OpdAdd, moduleName: allModules.Opd, permission: 'edit' },
];

